/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MobileServicesIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Mobile Services',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M34 4H2a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h32a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm-4 24H4V8h26Zm3-7.5a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5Z"
    />
    <path
      d="M7.019 25.686a1.249 1.249 0 0 1-.707-.383 1.13 1.13 0 0 1 .094-1.647l4.252-3.668a.631.631 0 0 1 .854.041l2.357 2.4 4.667-7.27a.625.625 0 0 1 1.055.035l2.147 3.712 3.95-8.015a1.233 1.233 0 0 1 1.638-.5 1.159 1.159 0 0 1 .545 1.575l-5.507 10.923a.623.623 0 0 1-1.083.016l-2.291-3.959-4.276 6.661a.625.625 0 0 1-.963.085l-2.786-2.837-2.93 2.565a1.246 1.246 0 0 1-1.016.266Z"
    />
  </svg>`;
};
